<template>
  <div v-if="connectionSSOOk">
    <div v-if="currentRouteName === 'callback' || user" class="layout layout--hasMenu">
      <div>
        <div>
          <RadioTutorial v-if="apiUser && (showTutorial || showAdminTutorial)" :user-role="apiUser.highestPrivilege" />
          <div class="no-gutters row">
            <div class="col-12">
              <AppHeader />
            </div>
          </div>
          <div class="row">
            <div class="col-12" />
          </div>

          <div class="d-flex">
            <div
              v-if="customerId && projectId"
              class="layout__menu menu__wrapper px-0 d-block col-md-4 col-lg-4 col-xl-3 col-12"
              :class="{
                'hidden-menu': menuHidden,
                'mobile-hidden': menuMobileHidden
              }"
            >
              <AppMenu />
            </div>
            <div :key="$route.fullPath" class="layout__content px-0 overflow-auto col">
              <div class="layout__slot">
                <div class="" style="max-width: 100%; width: 600px">
                  <div v-if="URLerrors.length > 0" class="alerts p-3" style="margin-top: 0; position: relative">
                    <div v-for="(error, index) in URLerrors" :key="index" class="alert alert-danger">
                      Připojení k {{ error.type }} trvá příliš dlouho.
                      <small>
                        Zkontrolujte přístup k
                        <a :href="error.link" target="_blank">{{ error.type }}</a>
                        a obnovte stránku.
                      </small>
                    </div>
                  </div>
                </div>

                <StoreNotify class="ml-4" :notifications="globalNotification" />

                <slot />
                <div v-if="isNoProjectPageInfoVisible && apiUser" class="layout__slot">
                  <div class="layout__content__content">
                    <div v-if="apiUser.isCustomerAdmin">
                      {{ $t("nemateZadnyProjektPrejdeteDoAdminMenu") }}
                      <div v-if="customerId" class="mt-3">
                        <button class="btn btn-primary" @click="openProjectCreation()">
                          {{ $t("CREATE_PROJECT") }}
                        </button>
                      </div>
                    </div>
                    <div v-else>
                      {{ $t("nemateZadnyProjekt") }}
                    </div>
                  </div>
                </div>
              </div>
              <footer class="layout__footer text-center mx-3 mx-md-5">
                <p>© {{ currentYear }} České Radiokomunikace a.s.</p>
                <p>by Picards</p>
              </footer>
            </div>
          </div>
        </div>
        <div v-if="!selectedProject && !isNoProjectVisible && !isNoProjectPageInfoVisible" class="atom-loader--project">
          <div class="side-box__overlay" />
          <AppLoader />
          <p class="text-center text-primary loading-text">{{ $t("nastavujeSeProjekt") }}...</p>
        </div>
      </div>
      <div v-if="waitingLoader">
        <LoaderWithOverlay :loader-title="waitingLoader" />
      </div>
      <div v-if="isPermissionErrorVisible">
        <ErrorPermissionsModal :centered="true" :opened="true" @close="logout" />
      </div>
      <div v-if="isTokenErrorVisible">
        <ErrorTokenModal :centered="true" :opened="true" @close="refresh" />
      </div>
      <div v-if="isLoginErrorVisible">
        <ErrorLoginModal :centered="true" :errors="['nepodariloSeZiskatToken']" :opened="true" @close="logout" />
      </div>
      <div v-if="isNoProjectVisible && apiUser">
        <ErrorLoginModal
          :centered="true"
          :errors="apiUser.isCustomerAdmin ? ['nemateZadnyProjektPrejdeteDoAdminMenu'] : ['nemateZadnyProjekt']"
          :opened="true"
          show-create-project-button
          @close="
            configStore.setNoProjectVisible({
              noProjectVisible: false,
              noProjectVisiblePageInfo: isNoProjectPageInfoVisible
            })
          "
        />
      </div>
      <div v-if="isCustomersErrorVisible">
        <ErrorCustomersModal :centered="true" :opened="true" @close="logout" />
      </div>
      <ErrorModal :centered="true" :errors="errors" :opened="!!errors.length" @close="clearErrors" />
    </div>
  </div>
  <div v-else class="p-3" style="max-width: 100%; width: 600px">
    <div v-if="URLerrors.length > 0" class="alerts" style="margin-top: 0; position: relative">
      <div class="alert alert-danger">
        Připojení k {{ URLerrors[0].type }} trvá příliš dlouho
        <small>
          Zkontrolujte přístup k
          <a :href="URLerrors[0].link" target="_blank">{{ URLerrors[0].type }}</a>
          a obnovte stránku.
        </small>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/header/header.vue"
import Menu from "@/components/menu/menu.vue"
import Tutorial from "@/components/radio/radio-tutorial.vue"
import Loader from "@/components/loader.vue"
import LoaderWithOverlay from "@/components/loaderWithOverlay.vue"
import ErrorModal from "@/components/confirmations/error.vue"
import ErrorPermissionsModal from "@/components/confirmations/permissions.vue"
import ErrorCustomersModal from "@/components/confirmations/customers.vue"
import ErrorTokenModal from "@/components/confirmations/token.vue"
import ErrorLoginModal from "@/components/confirmations/error.vue"
import StoreNotify from "@/components/notify/store-notify.vue"
import { mapMutations, mapState as mapStateVuex } from "vuex"
import { useAuthStore } from "@/store/modules/auth"
import { mapActions, mapState, mapWritableState } from "pinia"
import { useConfigStore } from "@/store/modules/config"
import { useProjectStore } from "@/store/modules/project"
import { useCustomerStore } from "@/store/modules/customer"

export default {
  components: {
    AppHeader: Header,
    AppMenu: Menu,
    RadioTutorial: Tutorial,
    AppLoader: Loader,
    LoaderWithOverlay,
    ErrorModal,
    ErrorPermissionsModal,
    ErrorCustomersModal,
    ErrorTokenModal,
    ErrorLoginModal,
    StoreNotify
  },
  setup() {
    const configStore = useConfigStore()

    return { configStore }
  },
  created() {
    if (!localStorage.getItem("showTutorialLater") && this.configStore.shouldShowTutorial) {
      this.configStore.isTutorialVisible = true
    }
    if (!localStorage.getItem("showEventTutorialLater") && this.configStore.shouldShowEventTutorial) {
      this.configStore.isEventTutorialVisible = true
    }
    if (!localStorage.getItem("showTutorialLaterAdmin") && this.configStore.shouldShowTutorialAdmin) {
      this.configStore.isAdminTutorialVisible = true
    }
  },
  computed: {
    ...mapStateVuex({
      errors: (state) => state.modals.errors
    }),
    customerId() {
      return this.selectedCustomer?.customerId
    },
    projectId() {
      return this.selectedProject?.projectId
    },
    menuHidden() {
      return this.$store.getters["menu/ifHideMenu"]
    },
    menuMobileHidden() {
      return this.$store.getters["menu/ifHideMobileMenu"]
    },
    showTutorial() {
      return (
        this.$router.currentRoute.value.name === "dashboard" &&
        (this.configStore.isTutorialVisible || this.configStore.isEventTutorialVisible)
      )
    },
    showAdminTutorial() {
      return this.$router.currentRoute.value.name === "admin" && this.configStore.isAdminTutorialVisible
    },
    waitingLoader() {
      return this.$store.getters["modals/waitingLoader"]
    },
    globalNotification() {
      return this.$store.getters["modals/globalNotification"]
    },
    currentRouteName() {
      return this.$route.name
    },
    currentYear() {
      return new Date().getFullYear()
    },
    ...mapState(useAuthStore, ["user", "apiUser"]),
    ...mapState(useProjectStore, ["selectedProject"]),
    ...mapState(useCustomerStore, ["selectedCustomer"]),
    ...mapState(useConfigStore, [
      "connectionSSOOk",
      "URLerrors",
      "isNoProjectPageInfoVisible",
      "isLoginErrorVisible",
      "isNoProjectVisible",
      "shouldShowEventTutorial",
      "shouldShowTutorial",
      "isTutorialVisible",
      "isAdminTutorialVisible",
      "isEventTutorialVisible"
    ]),
    ...mapWritableState(useConfigStore, ["isTokenErrorVisible"])
  },
  methods: {
    ...mapActions(useAuthStore, ["signOut"]),
    openProjectCreation() {
      /**
       * The sidebar — the only other way into the admin menu — is hidden without a project,
       * so this notice has to carry the way out itself. customerId is passed explicitly
       * because the route the notice shows on (e.g. home) has no params to inherit.
       */
      this.$router.push({
        name: "admin",
        params: { customerId: this.customerId },
        query: { createProject: true }
      })
    },
    ...mapMutations({
      clearErrors: "modals/clearErrors"
    }),
    logout() {
      this.configStore.clearLocalStorage()
      this.signOut()
    },
    refresh() {
      this.configStore.isTokenErrorVisible = false
      localStorage.setItem("reloaded", true)
      this.$router.go(0)
      this.$forceUpdate()
    }
  }
}
</script>
